import React from 'react';
import {Router} from 'react-router-dom';
import {RouterToUrlQuery} from 'react-url-query';

exports.replaceRouterComponent = ({history}) => {
  // eslint-disable-next-line
  const ConnectedRouterWrapper = ({children}) => (
    <Router history={history}>
      <RouterToUrlQuery>{children}</RouterToUrlQuery>
    </Router>
  );

  return ConnectedRouterWrapper;
};



// WEBPACK FOOTER //
// ./gatsby-browser.js